import styled, { css } from 'styled-components';

export const Error = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: ${theme.sz.s2};
    border-radius: ${theme.sz.s4};
    color: ${theme.co.secondary0};
    padding: ${theme.sz.s8} ${theme.sz.s10};
    z-index: ${theme.zi.z7};
    min-width: ${theme.sz.s32};
    max-width: ${theme.sz.ms};

    @media (max-width: ${theme.sz.ms}) {
      padding: ${theme.sz.s6} ${theme.sz.s4};
      align-items: center;
    }
  `,
);

export const ErrorTitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};

    @media (max-width: ${theme.sz.ms}) {
      text-align: center;
    }
  `,
);

export const ErrorMessage = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: ${theme.sz.ms}) {
      text-align: center;
    }
  `,
);
